import * as ko from 'knockout';
import { ppFetch } from '../shared/pp-fetch';

export class HomeComponent {
  announcements: KnockoutObservableArray<IWordPressPost> = ko.observableArray([]);

  constructor() {
    
  }
}
